// Coin Seller authentication (future use)
export const SET_COIN_SELLER = "SET_COIN_SELLER";
export const UNSET_COIN_SELLER = "UNSET_COIN_SELLER";
export const UPDATE_COIN_SELLER = "UPDATE_COIN_SELLER";
export const SIGNUP_COIN_SELLER = "SIGNUP_COIN_SELLER";

// Coin Seller dialog (future agar modal use karo)
export const OPEN_COIN_SELLER_DIALOG = "OPEN_COIN_SELLER_DIALOG";
export const CLOSE_COIN_SELLER_DIALOG = "CLOSE_COIN_SELLER_DIALOG";

// Coin Seller list & management
export const SET_COIN_SELLERS = "SET_COIN_SELLERS"; // all sellers
export const ACTIVE_INACTIVE_COIN_SELLER = "ACTIVE_INACTIVE_COIN_SELLER"; // toggle status
export const COIN_SELLER_ERROR = "COIN_SELLER_ERROR"; // error
export const CREATE_COIN_SELLER = "CREATE_COIN_SELLER"; // error
